export enum NodeTypeEnum {
    SYSTEM = 1,
    CUSTOM = 2,
    STICKY = 3,
    SCRATCHPAD_STATE = 4,
    INSTANCE_INFO = 5,
}